module.exports = __webpack_public_path__ + "img/menu_dots_active.33af72d2.svg";